import List from "@mui/material/List";
import { motion } from "framer-motion";
import FormHelperText from "@mui/material/FormHelperText";
import AddressListItem from "./AddressListItem";

const AddressList = ({ address, onChange, errors }) => {
	if (!address || address.length === 0) {
		return null;
	}
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<>
			<List className="p-0">
				<motion.div variants={container} initial="hidden" animate="show">
					{address.map((address, index) => (
						<motion.div
							variants={item}
							key={index}
							className="flex flex-col py-5"
						>
							<AddressListItem address={address} onChange={onChange} />
						</motion.div>
					))}
				</motion.div>
			</List>
			<div className="my-5">
				<FormHelperText error>{errors.address?.id?.message}</FormHelperText>
			</div>
		</>
	);
};

export default AddressList;
